import { observer } from 'mobx-react';
import React from 'react';
import { BrowseNavigationItemStyle, BrowseNavigationItemSelected } from '@udemy/browse-event-tracking';
import { Tracker } from '@udemy/event-tracking';
import { useI18n } from '@udemy/i18n';
import { range } from '@udemy/shared-utils';
import { ACADEMIES_NAV } from '../../../browse-constants';
import { CategoryNavItemSelectEvent } from '../../../events';
import { MOST_POPULAR_SUBCATEGORY_IDS } from '../../../fetch-popular-topics';
import { useMobileNavStore } from '../../../hooks/use-mobile-nav-store';
import { MobileAcademiesNavL2 } from '../level-two/mobile-academies-nav.react-component';
import styles from "../mobile-nav.module.css";
import { MobileNavItem, MobileNavL1Nav, MobileNavSection } from '../mobile-nav.react-component';
export const MobileFindCoursesNav = observer(() => {
  const mobileNavStore = useMobileNavStore();
  const {
    gettext
  } = useI18n();
  function handleSubcategoryNavClick(item) {
    const context = {
      categoryId: item.parentId,
      subcategoryId: item.id,
      topicId: null,
      uiRegion: 'mobile_nav'
    };
    Tracker.publishEvent(new CategoryNavItemSelectEvent({
      context
    }));
  }
  function handleAcademiesNavItemClick(item) {
    var _item$slug;
    const context = {
      type: item.type,
      id: (_item$slug = item.slug) !== null && _item$slug !== void 0 ? _item$slug : String(item.id),
      style: BrowseNavigationItemStyle.NAVIGATION_DROPDOWN,
      uiRegion: 'main_nav'
    };
    Tracker.publishEvent(new BrowseNavigationItemSelected(context));
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MobileNavL1Nav, {
    id: "header-toggle-side-nav-find-courses",
    title: gettext('Main Menu')
  }, /*#__PURE__*/React.createElement(MobileNavSection, null, /*#__PURE__*/React.createElement(MobileNavItem, {
    "data-purpose": "academies-link",
    cssToggleId: "header-toggle-side-nav-academies-l2",
    onClick: () => handleAcademiesNavItemClick(ACADEMIES_NAV(gettext).ALL_ACADEMIES)
  }, /*#__PURE__*/React.createElement("span", {
    className: styles['category-title']
  }, gettext('In-demand Careers')))), /*#__PURE__*/React.createElement(MobileNavSection, null, mobileNavStore.navigationCategories ? /*#__PURE__*/React.createElement(MobileNavItem, {
    cssToggleId: "header-toggle-side-nav-categories"
  }, gettext('All Categories')) : /*#__PURE__*/React.createElement(MobileNavItem, {
    loading: true
  }), mobileNavStore.mostPopularSubcategories ? mobileNavStore.mostPopularSubcategories.map(s => /*#__PURE__*/React.createElement(MobileNavItem, {
    onClick: () => handleSubcategoryNavClick(s),
    key: `most-popular-subcategory-item-${s.id}`,
    cssToggleId: `header-toggle-side-nav-popular-topics-of-${s.id}`,
    "data-purpose": "most-popular-subcategory-item"
  }, s.title)) : range(MOST_POPULAR_SUBCATEGORY_IDS.length).map(i => /*#__PURE__*/React.createElement(MobileNavItem, {
    key: `most-popular-id-${i}`,
    loading: true
  })))), mobileNavStore.isLevelLoaded(2) && /*#__PURE__*/React.createElement(MobileAcademiesNavL2, null));
});
//# sourceMappingURL=mobile-find-courses-nav.react-component.js.map